import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Utils from './core/utils'
import Hosts from './plugins/hosts'
import File from './plugins/file'
import HandleFile from './core/file'
import GjwBaseComponents from './components/gjwBase'
import StorageUtils from './core/storageUtils'
import Global from './core/global'
import { initDesktop } from './initDesktop'
import { initWeb } from './initWeb'
import Tracks from './core/tracks'
import './assets/elementThemes/blue/theme/index.css'
import './assets/css/index.less'
// eslint-disable-next-line no-irregular-whitespace
import './assets/gou/index.less'
import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import VueDragResize from 'vue-drag-resize'
import Api from './api'

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'small' })
Vue.use(VueClipboard)
Vue.use(Api)
Vue.use(File)
Vue.use(Tracks)
Vue.use(Hosts)
Vue.use(Global)
Vue.use(HandleFile)
Vue.use(GjwBaseComponents)
Vue.component('vue-drag-resize', VueDragResize)

// 根据url参数初始化主题风格, 如果没有，则显示默认风格（默认风格同R平台）
const platform = Utils.getUrlQuery('platform') || StorageUtils.sessionStorage.get('platform') || 'web'
StorageUtils.sessionStorage.set('platform', platform)
store.commit('setPlatform', platform)

// 取出插件端的插件类型和版本
const softwareCode = Utils.getUrlQuery('softwareCode') || StorageUtils.sessionStorage.get('softwareCode')
const softwareVersion = Utils.getUrlQuery('softwareVersion') || StorageUtils.sessionStorage.get('softwareVersion')

const initFn = platform !== 'web' ? initDesktop : initWeb
const payload = { softwareCode, softwareVersion }
initFn({ Vue, Store: store, Router: router }, payload).then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
})
